import { render, staticRenderFns } from "./failWin.vue?vue&type=template&id=81ed0260&scoped=true"
import script from "./failWin.vue?vue&type=script&lang=js"
export * from "./failWin.vue?vue&type=script&lang=js"
import style0 from "./failWin.vue?vue&type=style&index=0&id=81ed0260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ed0260",
  null
  
)

export default component.exports